import he from 'he';

/**
 * Decodes HTML entities in a given string.
 *
 * @param v - The string containing HTML entities to decode.
 * @returns The decoded string.
 */
export const decodeHTMLEntities = (v?: string): string => {
  if (!v) return '';

  return he.decode(v);
};
